




import Vue from 'vue';
import CommonOfficialDocumentError from '@/components/common/common-official-document-error.component.vue';

export default Vue.extend({
  components: {
    'common-official-document-error': CommonOfficialDocumentError
  }
});
